import { render, staticRenderFns } from "./xuanzeHy.vue?vue&type=template&id=2a013fb2&scoped=true&"
import script from "./xuanzeHy.vue?vue&type=script&lang=js&"
export * from "./xuanzeHy.vue?vue&type=script&lang=js&"
import style0 from "./xuanzeHy.vue?vue&type=style&index=0&id=2a013fb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a013fb2",
  null
  
)

export default component.exports